module.exports = __webpack_public_path__ + "static/media/participants-web.54312012.svg";